import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  row: {
    width: '100%',
    flexDirection: 'row',
  },
  cell: {
    backgroundColor: '#FFFCE8',
    color: '#53575A',
    fontFamily: 'Trebuchet',
    fontWeight: 'bold',
    width: 50,
    height: 40,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: 10,
    paddingBottom: 5,
    borderRight: '1px solid #BABABA',
  },
});

const ItemDetailsRow = ({ isTotal = false, isOdd = false }) => (
  <>
    <View style={styles.row}>
      <View
        style={{
          ...styles.cell,
          width: 72,
          height: 20,
          justifyContent: 'flex-end',
        }}>
        <Text></Text>
      </View>
      <View
        style={{
          ...styles.cell,
          width: 100,
          height: 20,
          justifyContent: 'flex-end',
        }}>
        <Text>Available this period</Text>
      </View>
      <View
        style={{
          ...styles.cell,
          width: 150,
          height: 20,
          justifyContent: 'flex-end',
        }}>
        <Text>Accounted For</Text>
      </View>
      <View
        style={{
          ...styles.cell,
          width: 72,
          height: 20,
          justifyContent: 'flex-end',
        }}>
        <Text></Text>
      </View>
      <View
        style={{
          ...styles.cell,
          width: 72,
          height: 20,
          justifyContent: 'flex-end',
        }}>
        <Text></Text>
      </View>
      <View
        style={{
          ...styles.cell,
          width: 72,
          height: 20,
          justifyContent: 'flex-end',
          borderRight: 0,
        }}>
        <Text></Text>
      </View>
    </View>
    <View style={styles.row}>
      <View
        style={{
          ...styles.cell,
          width: 72,
        }}>
        <Text>Items</Text>
      </View>
      <View
        style={{
          ...styles.cell,
        }}>
        <Text>Beginning</Text>
        <Text>Inventory</Text>
      </View>
      <View
        style={{
          ...styles.cell,
        }}>
        <Text>Delivered</Text>
      </View>
      <View
        style={{
          ...styles.cell,
        }}>
        <Text>Returned</Text>
        <Text>Dirty</Text>
      </View>
      <View
        style={{
          ...styles.cell,
        }}>
        <Text>Returned</Text>
        <Text>Unused</Text>
      </View>
      <View
        style={{
          ...styles.cell,
        }}>
        <Text>Ending</Text>
        <Text>Inventory</Text>
      </View>
      <View
        style={{
          ...styles.cell,
          width: 72,
        }}>
        <Text>Lost</Text>
        <Text style={{ fontSize: 6, fontWeight: 'normal' }}>
          Available - Accounted
        </Text>
      </View>
      <View
        style={{
          ...styles.cell,
          width: 72,
        }}>
        <Text>Used</Text>
        <Text style={{ fontSize: 6, fontWeight: 'normal' }}>Dirty + Lost</Text>
      </View>
      <View
        style={{
          ...styles.cell,
          width: 72,
          borderRight: 0,
        }}>
        <Text>Return Rate</Text>
        <Text style={{ fontSize: 6, fontWeight: 'normal' }}>
          Accounted For / Available
        </Text>
      </View>
    </View>
  </>
);

export default ItemDetailsRow;
